import { useNg3DsRedirection } from "@sazka/ng/ng-3ds-redirection";
import { ngFrameworkLoaded } from "@sazka/ng/ng-integration";
import { useLotteryCheckoutManager } from "../online/shared/lottery-checkout/lottery-checkout-manager";

export const useLottery3DSRedirection = async () => {
    await ngFrameworkLoaded();

    useNg3DsRedirection().beforeRedirection(async () => {
        await useLotteryCheckoutManager().onDepositRedirectionStart();
    });

    useLotteryCheckoutManager().registerCheckoutCallbacks();
};
